export const TUTOR_NAME = 'Orbit';
